import clsx from "clsx";
import React, { FC } from "react";

import { PaginationIndicatorItemProps } from "./pagination-indicator-item-props";

export const PaginationIndicatorDot: FC<PaginationIndicatorItemProps> = ({
  onClick,
  isActive,
  activeItemClassName,
  inactiveItemClassName,
}) => (
  <div
    className={clsx(
      "w-4 h-4 rounded-full transition-colors",
      onClick && "cursor-pointer",
      isActive ? activeItemClassName : inactiveItemClassName
    )}
    onClick={onClick}
  />
);
